var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerifyGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M15.9845 2.65493L10.7637 1.09872C10.5927 1.04782 10.4079 1.04782 10.237 1.09872L5.01616 2.65493C4.18608 2.90142 3.46401 3.3755 2.95253 4.00979C2.44105 4.64409 2.16619 5.40634 2.16699 6.18826V10.0002C2.16699 15.6343 9.83366 18.746 10.162 18.8756C10.2685 18.9179 10.3838 18.9398 10.5003 18.9398C10.6169 18.9398 10.7321 18.9179 10.8387 18.8756C11.167 18.746 18.8337 15.6343 18.8337 10.0002V6.18826C18.8345 5.40634 18.5596 4.64409 18.0481 4.00979C17.5366 3.3755 16.8146 2.90142 15.9845 2.65493Z",
    fill: "#71DD5F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9845 2.65488L10.7637 1.09872C10.5927 1.04782 10.4079 1.04782 10.237 1.09872L5.01616 2.65488C4.18608 2.90136 3.46401 3.37542 2.95253 4.00969C2.44105 4.64396 2.16619 5.40619 2.16699 6.18808V9.99989C2.16699 15.6338 9.83366 18.7454 10.162 18.875C10.2685 18.9173 10.3838 18.9391 10.5003 18.9391C10.6169 18.9391 10.7321 18.9173 10.8387 18.875C11.167 18.7454 18.8337 15.6338 18.8337 9.99989V6.18808C18.8345 5.40619 18.5596 4.64396 18.0481 4.00969C17.5366 3.37542 16.8146 2.90136 15.9845 2.65488ZM17.167 9.99989C17.167 14.0635 11.9012 16.7288 10.5003 17.3665C9.09783 16.7311 3.83366 14.0739 3.83366 9.99989V6.18808C3.83371 5.71898 3.99889 5.26179 4.3058 4.88128C4.61271 4.50077 5.04578 4.21625 5.54366 4.06801L10.5003 2.59081L15.457 4.06801C15.9549 4.21625 16.3879 4.50077 16.6949 4.88128C17.0018 5.26179 17.1669 5.71898 17.167 6.18808V9.99989Z",
    fill: "#71DD5F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.39258 9.28543L10.1828 12.0756L13.9935 6.97838",
    stroke: "#71DD5F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifyGreen);
export default __webpack_public_path__ + "static/media/verify_green.0b55edfc6fd7c8d4fe76d1be006113c6.svg";
export { ForwardRef as ReactComponent };